import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/opt/build/repo/www/src/layouts/ApiLayout.js"
import { graphql } from 'gatsby';
import ComponentApi from '../../components/ComponentApi';
import ReactPlayground from '../../components/ReactPlayground';
import CarouselControlled from '../../examples/Carousel/Controlled';
import CarouselUncontrolled from '../../examples/Carousel/Uncontrolled';
export const query = graphql`
  query CarouselQuery {
    carousel: componentMetadata(displayName: { eq: "Carousel" }) {
      displayName
      ...ComponentApi_metadata
    }
    item: componentMetadata(displayName: { eq: "CarouselItem" }) {
      displayName
      ...ComponentApi_metadata
    }
    caption: componentMetadata(displayName: { eq: "CarouselCaption" }) {
      displayName
      ...ComponentApi_metadata
    }
  }
`;

export default ({components, ...props}) => <MDXTag name="wrapper" Layout={DefaultLayout} layoutProps={props} components={components}>



<MDXTag name="h1" components={components} props={{"id":"carousels"}}>{`Carousels`}</MDXTag>
<p classname="lead">
  A slideshow component for cycling through elements—images or slides of
  text—like a carousel.
</p>

<MDXTag name="h2" components={components} props={{"id":"example"}}>{`Example`}</MDXTag>
<MDXTag name="p" components={components}>{`Carousels don’t automatically normalize slide dimensions. As such, you
may need to use additional utilities or custom styles to appropriately
size content. While carousels support previous/next controls and
indicators, they’re not explicitly required. Add and customize as you
see fit.`}</MDXTag>
<ReactPlayground codeText={CarouselUncontrolled} />
<MDXTag name="h2" components={components} props={{"id":"controlled"}}>{`Controlled`}</MDXTag>
<MDXTag name="p" components={components}>{`You can can also `}<MDXTag name="em" components={components} parentName="p">{`control`}</MDXTag>{` the Carousel state, via the
`}<MDXTag name="inlineCode" components={components} parentName="p">{`activeIndex`}</MDXTag>{` prop and `}<MDXTag name="inlineCode" components={components} parentName="p">{`onSelect`}</MDXTag>{` handler.`}</MDXTag>
<ReactPlayground codeText={CarouselControlled} />
<MDXTag name="h2" components={components} props={{"id":"api"}}>{`API`}</MDXTag>
<ComponentApi metadata={props.data.carousel} />
<ComponentApi metadata={props.data.item} exportedBy={props.data.carousel} />
<ComponentApi metadata={props.data.caption} exportedBy={props.data.carousel} />
</MDXTag>

export const _frontmatter = {};

  